import { Component, OnInit } from '@angular/core';
import { Button } from 'primeng/button';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'd2d-page-not-found',
  imports: [Button, RouterLink],
  templateUrl: './page-not-found.component.html',
})
export class PageNotFoundComponent implements OnInit {
  funnyMessages = [
    'Intentaste entrar a esta página pero no existe... ¡como mis excusas para no hacer ejercicio!',
    'Esta página se ha ido de vacaciones sin avisar... ¡qué desconsiderada!',
    'Has encontrado el tesoro digital... ¡pero está en otro castillo!',
    'Esta página es como mi motivación los lunes... simplemente no existe.',
    'Parece que esta URL tomó un desvío equivocado en el ciberespacio.',
    'Esta página es tan difícil de encontrar como un calcetín perdido.',
    '¡Felicidades! Has descubierto un rincón inexplorado de internet.',
    'Esta página es más esquiva que mi gato cuando es hora del baño.',
    'Has llegado a la tierra de las páginas perdidas... población: esta URL.',
  ];

  currentMessage = '';

  ngOnInit() {
    // this.randomMessage();
    this.changeMessage();
  }

  randomMessage() {
    const _interval = setInterval(() => {
      this.changeMessage();
    }, 7000);
  }

  changeMessage() {
    this.currentMessage = this.funnyMessages[Math.floor(Math.random() * this.funnyMessages.length)];
  }
}
